import { Entity, JoinColumn, ManyToOne, OneToMany, ManyToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';
import Change from '../changes/change.entity';
import CmStorageLocation from '../cm-storage-locations/cm-storage-location.entity';
import CmWrapBoxEpisodicItem from '../cm-wrap-box-episodic-items/cm-wrap-box-episodic-item.entity';
import { DEPARTMENTS } from '../enums/enums';
import WrapBox from '../wrap-boxes/wrap-box.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';

@Entity('cm_wrap_boxes')
export default class CmWrapBox extends WrapBox {
	static tableName = 'cm_wrap_boxes';
	static deptId = DEPARTMENTS.CM;

	@OneToMany(
		(type) => CmWrapBoxEpisodicItem,
		(cmWrapBoxEpItem) => cmWrapBoxEpItem.cmWrapBox
	)
	cmWrapBoxEpisodicItems: CmWrapBoxEpisodicItem[];

	@ManyToMany(() => EpisodicItem, (episodicItem) => episodicItem.cmWrapBoxes)
	episodicItems: EpisodicItem[];

	@OneToMany((type) => Change, (change) => change.wrapBox)
	changes: Change[];

	@ManyToOne(
		(type) => CmStorageLocation,
		(cmStorageLocation) => cmStorageLocation.cmWrapBoxes
	)
	@JoinColumn({
		name: 'storage_location_id',
	})
	cmStorageLocation: CmStorageLocation;

	readonly department = CmWrapBox.deptId;

	static rules() {
		return {
			...super.rules(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
		};
	}

	assign(props?: GenPartial<CmWrapBox>) {
		super.assign(props);
	}

	constructor(props?: GenPartial<CmWrapBox>) {
		super(props);
	}
}
